import { AwaitContainer, Button, DialogRoot, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useHasPermission } from '@/entities/profile';
import { useReportRule } from '../model';

type Props = {
  ruleId?: number;
  expertReportId: number;
  blockId: number;
  onClose: () => void;
};

export const RuleDetailDialog: FC<Props> = ({ ruleId, expertReportId, blockId, onClose }) => {
  const { t } = useTranslation(['dialogs']);
  const { title, name, text, isLoading, path } = useReportRule({ ruleId, expertReportId, blockId });
  const canViewExpertReport = useHasPermission('VIEW_EXPERT_REPORT');
  return (
    <DialogRoot open={!!ruleId} onOpenChange={(open: boolean) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{`${title}: ${name}`}</DialogTitle>
        </DialogHeader>
        <AwaitContainer isLoading={isLoading}>
          <div className="whitespace-pre-wrap text-sm">{text}</div>
        </AwaitContainer>
        <DialogFooter className="flex items-center">
          {/* Переход ведёт туда, где открытое живёт в устройстве своего заключения */}
          {canViewExpertReport && path && (
            <Link to={path} className="text-primary underline text-sm hover:text-primary/80">
              {t('expertReport.openCard')}
            </Link>
          )}
          <Button variant="outline" onClick={onClose}>
            {t('expertReport.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
